import {
  getBankDetailsAPI,
  addBankDetailsAPI,
  updateBankDetailsAPI,
  deleteBankDetailsAPI
} from '../adapter/adapter'

export function getAllBanksHelper() {
  let promise = new Promise(function (resolve, reject) {
    getBankDetailsAPI()
      .then((res) => {
        console.log('getAllBanksHelper res: ', res.data)

        if (res?.data?.error) {
          reject(res.data.error.message)
        } else if (res?.data?.data) {
          resolve(res.data.data)
        } else {
          reject('Get Banks Failure')
        }
      })
      .catch((err) => {
        console.log('getAllBanksHelper err: ', err)
        reject('Get Banks Failure')
      })
  })

  return promise
}

export function addBankHelper(data) {
  let reqData = {
    ac_name: data.ac_name,
    ac_number: data.ac_number,
    routing_number: data.routing_number,
    bank_name: data.bank_name,
    branch_name: data.branch_name
  }

  let promise = new Promise(function (resolve, reject) {
    addBankDetailsAPI(reqData)
      .then((res) => {
        console.log('addBankHelper res: ', res.data)

        if (res?.data?.error) {
          reject(res.data.error.message)
        } else if (res?.data?.data) {
          resolve(res.data.data)
        } else {
          reject('Add Bank Failure')
        }
      })
      .catch((err) => {
        console.log('addBankHelper err: ', err)
        reject('Add Bank Failure')
      })
  })

  return promise
}

export function updateBankHelper(data) {
  let reqData = {
    id: data.id,
    ac_name: data.ac_name,
    ac_number: data.ac_number,
    routing_number: data.routing_number,
    bank_name: data.bank_name,
    branch_name: data.branch_name
  }

  let promise = new Promise(function (resolve, reject) {
    updateBankDetailsAPI(reqData)
      .then((res) => {
        console.log('updateBankHelper res: ', res.data)

        if (res?.data?.error) {
          reject(res.data.error.message)
        } else if (res?.data?.data) {
          resolve(res.data.data)
        } else {
          reject('Update Bank Failure')
        }
      })
      .catch((err) => {
        console.log('updateBankHelper err: ', err)
        reject('Update Bank Failure')
      })
  })

  return promise
}

export function deleteBankHelper(id) {
  let reqData = {
    id: id
  }

  let promise = new Promise(function (resolve, reject) {
    deleteBankDetailsAPI(reqData)
      .then((res) => {
        console.log('deleteBankHelper res: ', res.data)

        if (res?.data?.error) {
          reject(res.data.error.message)
        } else if (res?.data?.code === 200) {
          resolve(true)
        } else {
          reject('Delete Bank Failure')
        }
      })
      .catch((err) => {
        console.log('deleteBankHelper err: ', err)
        reject('Delete Bank Failure')
      })
  })

  return promise
}

